import { functionsBaseUrl } from "../config/runtime";
import { authenticatedJson } from "./guestSession";

export const completePrintJob = (jobId) => authenticatedJson(
    `${functionsBaseUrl}/completePrintJob`,
    { jobId }
);
